import { render } from "./DoctoresView.vue?vue&type=template&id=f6148106&ts=true"
import script from "./DoctoresView.vue?vue&type=script&lang=ts"
export * from "./DoctoresView.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\RESPALDO 17-01-26 PC\\git\\adminSanatorio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__